var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('pt-button', { attrs: { "type": _vm.PtButtonType.Outlined, "theme": _vm.PtButtonTheme.Primary }, on: { "click": _vm.resetTemplate } }, [_vm.$slots.default ? _vm._t("default") : [_vm._v("\n    " + _vm._s(_vm.$t('playTurbo.commonTemplate.resetTemplate.text')) + "\n  ")]], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };